<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <p></p>
    <v-card width="100%">
      <v-card-text>
        <v-row v-if="routes">
          <v-col>
              <h1>Rotas</h1>
          </v-col>
          <v-col>
            <v-alert dense text type="info">
              {{ routes.length }} rotas encontrados
            </v-alert>
          </v-col>
        </v-row>
        <v-simple-table v-if="routes">
          <thead>
            <tr>
              <th>Prefixo</th>
              <th>Nome</th>
              <th>Preço</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in routes" :key="item.id">
              <td>{{ item.prefix }}</td>
              <td>{{ item.name }}</td>
              <td>R$ {{ item.pricePerMinute | formatRate }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    routes: null,
    dialog_loading: false,
  }),
  created: function () {
    this.load();
    this.loadRoutes();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/plan/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    loadRoutes: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/routeplan/plan/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.routes = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar rotas!");
          console.log(error);
        });
    }
  },
};
</script>